import React, { useEffect } from "react";
import { Header } from "../../internal/Header/Header";
import { navigate, useLocation } from "@reach/router";
import { getIdFromUrl } from "../../../helpers/functions";
import labels from "../../../helpers/labels.json";
import useStatus from "../../../hooks/useStatus";
import { Layout } from "../../../styles/component/style";

export default function SheduleRoute({ showSidebar = true, children }) {
  const location = useLocation();
  const { globalId, setGlobalId } = useStatus();

  const pathSegments = location.pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];

  /**
   * @description maintain global id hook
   */

  useEffect(() => {
    if (getIdFromUrl(location.pathname) > 0 && lastSegment && !globalId) {
      setGlobalId(lastSegment);
      window.scrollTo(0, 0);
    } else if (getIdFromUrl(location.pathname) === 0 && globalId) {
      navigate(`${location.pathname}/${globalId}`);
      window.scrollTo(0, 0);
    }
    if (
      getRelevantSegments(location.pathname).includes("dashboard") ||
      getRelevantSegments(location.pathname).includes("home") ||
      getRelevantSegments(location.pathname).includes("organisation") ||
      getRelevantSegments(location.pathname).includes("events") ||
      getRelevantSegments(location.pathname).includes("downloads") ||
      getRelevantSegments(location.pathname).includes("event-host") ||
      getRelevantSegments(location.pathname).includes("view-events") ||
      getRelevantSegments(location.pathname).includes("view-hosts") ||
      getRelevantSegments(location.pathname).includes("view-organisation")
    ) {
      setGlobalId("");
      navigate(location.pathname);
      window.scrollTo(0, 0);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const getRelevantSegments = (url) => {
    const pathSegments = url.split("/").filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1];

    // Check if last segment is an ID (either number or alphanumeric)
    if (/^[a-zA-Z0-9]+$/.test(lastSegment)) {
      return pathSegments.slice(-2).join("/"); // Take last two segments
    } else {
      return pathSegments.slice(-1).join("/"); // Take only the last one
    }
  };

  /* selected sidebar sub item */

  let selectedSubItem =
    getRelevantSegments(location.pathname) === "organisation"
      ? labels.create_organisation
      : getRelevantSegments(location.pathname) === "create-organisation"
      ? labels.create_organisation
      : getRelevantSegments(location.pathname) === "view-organisation"
      ? labels.modify_organisation
      : getRelevantSegments(location.pathname) === "event-host"
      ? labels.organization_create_host
      : getRelevantSegments(location.pathname) === "create-event-host"
      ? labels.organization_create_host
      : getRelevantSegments(location.pathname) === "view-event-host"
      ? labels.organization_view_host
      : getRelevantSegments(location.pathname).includes("form-settings")
      ? labels.user_access_registration
      : getRelevantSegments(location.pathname) === "form-settings"
      ? labels.user_access_registration
      : getRelevantSegments(location.pathname) === "user-access-registration"
      ? labels.user_access_registration
      : getRelevantSegments(location.pathname).includes(
          "user-access-registration",
        )
      ? labels.user_access_registration
      : getRelevantSegments(location.pathname) === "custom-filed-addition"
      ? labels.custom_filed_addition
      : getRelevantSegments(location.pathname).includes("custom-filed-addition")
      ? labels.custom_filed_addition
      : getRelevantSegments(location.pathname) === "view-hosts"
      ? labels.organization_view_host
      : getRelevantSegments(location.pathname).includes("view-organisation")
      ? labels.modify_organisation
      : getRelevantSegments(location.pathname).includes("view-hosts")
      ? labels.organization_view_host
      : getRelevantSegments(location.pathname).includes("organisation")
      ? labels.create_organisation
      : "";

  return (
    <Layout>
      <Header
        {...{ showSidebar }}
        selectedItem={
          location.pathname.includes("home")
            ? labels.home
            : location.pathname.includes("organisation")
            ? labels.organisation
            : location.pathname.includes("event-host")
            ? labels.event_host
            : location.pathname.includes("event-details")
            ? getIdFromUrl(location.pathname) > 0
              ? labels.event_details
              : labels.create_new_event
            : location.pathname.includes("form-settings")
            ? labels.form_settings
            : location.pathname.includes("event-settings")
            ? labels.event_settings
            : location.pathname.includes("theme-settings")
            ? labels.theme_settings
            : location.pathname.includes("speakers")
            ? labels.speakers
            : location.pathname.includes("resources")
            ? labels.resources
            : location.pathname.includes("safe-harbor")
            ? labels.safe_harbor
            : location.pathname.includes("additional-tabs")
            ? labels.additional_tabs
            : location.pathname.includes("email-templates")
            ? labels.email_templates
            : location.pathname.includes("feedback")
            ? labels.feedback
            : location.pathname.includes("communicate")
            ? labels.communicate
            : location.pathname.includes("polling")
            ? labels.polling
            : location.pathname.includes("tickers")
            ? labels.tickers
            : location.pathname.includes("preview")
            ? labels.preview
            : location.pathname.includes("faqs")
            ? labels.faqs
            : location.pathname.includes("help")
            ? labels.help
            : labels.q_and_a
        }
        selectedSubItem={selectedSubItem}
        // selectedItem={
        //   location.pathname.includes("event-details")
        //     ? getIdFromUrl(location.pathname) > 0
        //       ? labels.event_details
        //       : selectedItem
        //     : selectedItem
        // }
      >
        {children}
      </Header>
    </Layout>
  );
}
